// Copyright ©️ 2026 eVolve MEP, LLC

import {
  BendPreviewGeometry,
  type BendPreviewSpecifications,
} from 'modules/Shop/EvolveFabrication/BendCreator/BendPreview/BendPreviewGeometry';
import { convertToRadians } from 'modules/Shop/EvolveFabrication/BendCreator/BendPreview/helpers';

export class AngledGeometry extends BendPreviewGeometry {
  getDefaultDimensions() {
    // The bend can be overdefined.
    return {
      ...super.getDefaultDimensions(),
      angle: 45,
      centerToEnd1: 4 * Math.sqrt(2),
      centerToEnd2: 5,
      kickHeight: 4,
    };
  }

  createBendDefs(dimensions: BendPreviewSpecifications) {
    const { angle, centerToEnd1, centerToEnd2, kickHeight } = dimensions;
    const theta = convertToRadians(angle);
    const legLength = kickHeight / Math.tan(theta);
    return [
      {
        runLength: centerToEnd2,
        thenBendBy: theta,
        startLabels: [{ label: 'Center to End 2', length: centerToEnd2 }],
        endLabels: [{ label: 'Angle', angle, radius: Math.min(1, legLength * 0.75) }],
      },
      {
        runLength: centerToEnd1,
        startLabels: [
          {
            label: 'Center to End 1',
            length: centerToEnd1,
            directionPreference: 'inward',
            preferredDistance: 0.2,
            canPlaceInsideGeometry: true,
          },
        ],
        endLabels: [
          {
            label: 'Kick Height',
            length: kickHeight,
            isVertical: true,
            offsets: [{ relativeTo: 'bendPlane', offset: 'bottom' }],
          },
        ],
      },
    ] as const;
  }
}
